export class Globals {
  currentUserName?:string;
  currentUserEmail?:string;
  currentUserId?:string;
  viewContactsFlag?:boolean;
}